/**
 * @author wangyingxu1
 * api map
 */

 export default {
  // 选项
  baseLabelOptions: '/auth/api/getPerDataListApi'
};
